import { useState } from "react";
import { Lock, Mail, Loader2, ShieldCheck } from "lucide-react";

export function AuthShell({ title, subtitle, children }) {
  return (
    <section className="min-h-[calc(100vh-74px)] grid lg:grid-cols-[1.1fr_1fr]">
      <div className="hidden lg:flex flex-col justify-end p-14 bg-[#0F2A6B] relative grain overflow-hidden">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#4CB944]/20 blur-3xl" />
        <div className="relative">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 text-[#4CB944] text-xs font-semibold uppercase tracking-wider"><ShieldCheck className="w-4 h-4" /> Accès sécurisé</div>
          <h1 className="mt-6 text-4xl xl:text-5xl font-bold text-white font-head leading-tight">Votre Espace client<br /><span className="text-[#4CB944]">VISION LOGICIELS</span></h1>
          <p className="mt-5 text-slate-300 max-w-md">Consultez vos devis et factures, et suivez vos demandes de support en temps réel.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm">
          <h2 className="text-3xl font-bold text-[#0F2A6B] font-head">{title}</h2>
          <p className="text-sm text-slate-500 mt-2">{subtitle}</p>
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </section>
  );
}

export function AuthInput({ icon: Icon = Mail, ...props }) {
  return (
    <div className="relative">
      <Icon className="w-4 h-4 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2" />
      <input {...props} className="w-full pl-10 pr-4 py-3 rounded-xl bg-white border border-slate-200 text-slate-900 placeholder-slate-400 focus:border-[#0F2A6B] focus:ring-2 focus:ring-[#0F2A6B]/10 focus:outline-none transition-colors" />
    </div>
  );
}

export function SubmitButton({ loading, children, ...props }) {
  return (
    <button type="submit" disabled={loading} {...props}
      className="w-full mt-6 flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#0F2A6B] text-white font-semibold hover:bg-[#0A1F52] hover:shadow-lg hover:shadow-[#0F2A6B]/25 disabled:opacity-60 transition-[background-color,box-shadow]">
      {loading && <Loader2 className="w-4 h-4 animate-spin" />}{children}
    </button>
  );
}

export const usePending = () => {
  const [loading, setLoading] = useState(false);
  const run = async (fn) => { setLoading(true); try { await fn(); } finally { setLoading(false); } };
  return [loading, run];
};

export { Lock };
